const luxon = require("luxon");
const yaml = require('js-yaml');
const uuid = require("uuid");

// 全局router
let glbalRouter = null;

module.exports = {
    getBackendApiBase() {
        if (process.env.NODE_ENV == "dev") {
            return process.env.VUE_APP_BACKEND_API_BASE
        } else {
            return window.location.origin;
        }
    },

    /**
     * 保存全局router
     */
    saveGlobalRouter(router) {
        glbalRouter = router;
    },

    /**
     * 跳转到登录页面
     */
    gotoLoginPage() {
        glbalRouter.push({ name: "login" });
    },

    /**
     * 往localStorage里保存数据
     * @param {*} key 
     * @param {*} value 
     * @param {*} expireAfterSeconds 多久以后过期，单位是秒。小于或等于0则表示永不过期。
     */
    storeToLocalStorage(key, value, expireAfterSeconds) {
        // 过期时间，unixtime，单位是秒
        let expireAfter = 0;
        if (expireAfterSeconds > 0) {
            expireAfter = Math.round((new Date()).getTime() / 1000) + expireAfterSeconds;
        }

        let v = {
            value: value,
            expireAfter: expireAfter,
        };

        localStorage.setItem(key, JSON.stringify(v));
    },

    /**
     * 从localStorage里读取数据
     * @param {*} key 
     * @returns 
     */
    getFromLocalStorage(key) {
        let vStr = localStorage.getItem(key);
        if (!vStr) {
            return "";
        }

        let v = JSON.parse(vStr);
        if (v.expireAfter > 0 && v.expireAfter <= Math.round((new Date()).getTime() / 1000)) {
            localStorage.removeItem(key);
            return ""
        }

        return v.value;
    },

    /**
     * 从localStorage里删除数据
     * @param {*} key 
     * @returns 
     */
    removeFromLocalStorage(key) {
        localStorage.removeItem(key);
    },

    ms2day(ts) {
        return luxon.DateTime.fromMillis(parseInt(ts)).toFormat("yyyy-MM-dd");
    },

    ms2datetime(ts) {
        return luxon.DateTime.fromMillis(parseInt(ts)).toFormat("yyyy-MM-dd HH:mm:ss");
    },

    ms2ymdhm(ts) {
        return luxon.DateTime.fromMillis(parseInt(ts)).toFormat("yyyy-MM-dd HH:mm");
    },

    /** 
     * 设置favicon
    */
    setFavicon(url) {
        // 获取 head 标签
        var head = document.getElementsByTagName('head')[0];

        // 获取当前 favicon 元素
        var favicon = document.querySelector("link[rel*='icon']") || document.createElement('link');
        favicon.type = 'image/x-icon';
        favicon.rel = 'shortcut icon';

        // 设置新的 favicon 地址
        favicon.href = url;

        // 如果当前 head 标签中不存在 favicon 元素，则将新的 favicon 添加到 head 标签中
        if (!document.querySelector("link[rel*='icon']")) {
            head.appendChild(favicon);
        }
    },

    string2yaml(obj) {
        let yamlStr
        yaml.loadAll(obj, function (doc) {
            yamlStr = yaml.dump(doc, {
                'styles': {
                    '!!null': 'canonical'
                },
                'sortKeys': true
            })
        });
        return yamlStr
    },

    uuid() {
        return uuid.v4();
    },

    string2PositiveInt(e) {
        let val = Number(e);
        if (isNaN(val) || val != parseInt(val)) {
            return {
                value: 0,
                err: "格式错误",
            };
        }

        if (val <= 0) {
            return {
                value: 0,
                err: "必须是正整数",
            };
        }

        return {
            value: val
        }
    },
    number2ZhWeek(val) {
        switch (val) {
            case 1: return "一"
            case 2: return "二"
            case 3: return "三"
            case 4: return "四"
            case 5: return "五"
            case 6: return "六"
            case 7: return "日"
        }

        return val
    },

    async setCookie(key, value) {
        document.cookie = key + "=" + value
    },


    async getCookie(key) {
        var name = key + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i].trim();
            if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
        }
        return "";
    },
}